import { MoreVertical } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

import { DataTableRow, TableAction } from '../types';

interface RowActionsProps<T extends DataTableRow> {
  actions: TableAction<T>[];
  row: T;
}

export function RowActions<T extends DataTableRow>({ actions, row }: RowActionsProps<T>) {
  if (actions.length === 0) return null;

  return (
    <div className="flex items-center gap-1">
      {actions.slice(0, 2).map((action) => (
        <Button key={action.id} variant="outline" size="icon" className="h-9 w-9" onClick={() => action.onClick?.(row)}>
          {action.icon && <action.icon className="w-4 h-4" />}
        </Button>
      ))}

      {actions.length > 2 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="h-9 w-9">
              <MoreVertical className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {actions.slice(2).map((action) => (
              <DropdownMenuItem key={action.id} onClick={() => action.onClick?.(row)}>
                {action.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
